import type { LocaleMessageBundle } from '../../types'

export const cashTransactionMessages: LocaleMessageBundle = {
  vi: {
    'cashTransaction.model': 'phiếu thu chi',
    'cashTransaction.sourceBadge': 'Nhập tay',
    'cashTransaction.sourceHint': 'Phiếu được nhập trực tiếp, không phát sinh từ chứng từ nào.',
    'cashTransaction.summary.totalIn': 'Tổng thu',
    'cashTransaction.summary.totalOut': 'Tổng chi',
    'cashTransaction.summary.net': 'Chênh lệch',
    'cashTransaction.actions.create': 'Thêm phiếu',
    'cashTransaction.dialog.createSubtitle': 'Ghi nhận thu/ chi thủ công',
    'cashTransaction.dialog.cancelTitle': 'Hủy phiếu',
    'cashTransaction.messages.cancelConfirm': 'Bạn có chắc muốn hủy phiếu {code}?',
    'cashTransaction.errors.loadFailed': 'Không thể tải danh sách thu/chi',
    'cashTransaction.errors.saveFailed': 'Không thể lưu phiếu',
    'cashTransaction.errors.cancelFailed': 'Không thể hủy phiếu',
  },
  en: {
    'cashTransaction.model': 'cash transaction',
    'cashTransaction.sourceBadge': 'Manual',
    'cashTransaction.sourceHint': 'Entered directly, not generated from any document.',
    'cashTransaction.summary.totalIn': 'Total in',
    'cashTransaction.summary.totalOut': 'Total out',
    'cashTransaction.summary.net': 'Net',
    'cashTransaction.actions.create': 'Add entry',
    'cashTransaction.dialog.createSubtitle': 'Record manual cash in/ out',
    'cashTransaction.dialog.cancelTitle': 'Cancel entry',
    'cashTransaction.messages.cancelConfirm': 'Are you sure you want to cancel entry {code}?',
    'cashTransaction.errors.loadFailed': 'Failed to load cash transactions',
    'cashTransaction.errors.saveFailed': 'Failed to save entry',
    'cashTransaction.errors.cancelFailed': 'Failed to cancel entry',
  },
}
